import { FormInstance } from "@wingspanhq/wingspan-api-sdk";
import { FormChecklistStatus, IFormChecklistItem } from "../types";

const deriveStatus = (
  status: Pick<FormInstance, "completedAt" | "blockedByIds" | "events">
): FormChecklistStatus => {
  if (status.events?.rejectedAt && !status.completedAt) {
    return "Rejected";
  }
  if (status.completedAt) {
    return "Completed";
  }
  if ((status.blockedByIds?.length ?? 0) > 0) {
    return "Locked";
  }
  return "Available";
};

/**
 * Adapts a single per-instance status read (GET /:formId?expand=BlockedByIds)
 * into the shared checklist item shape the requirement-page widget already
 * renders. `blockedBy` holds sibling INSTANCE ids here (not catalog formIds,
 * unlike the /checklist-sourced item) — every reader of this field only
 * checks its length or displays its first entry, so the field is repurposed
 * rather than renamed. `metadata` (catalog jurisdiction) has no equivalent on
 * this source, so it's left unset — a known, accepted display gap.
 *
 * The SDK's generated model types every field optional; a real instance
 * always has an id/type/revision, so the `?? ""` fallbacks here are just
 * satisfying the wider generated type, not real degradation.
 */
export const selectorFormChecklistItemFromInstanceStatus = (
  status: FormInstance
): IFormChecklistItem => ({
  id: status.id ?? "",
  formId: status.type ?? "",
  title: status.title ?? status.type ?? "",
  version: status.revision ?? "",
  status: deriveStatus(status),
  blockedBy: status.blockedByIds ?? [],
  completedAt: status.completedAt ?? undefined,
  rejectedAt: status.events?.rejectedAt ?? undefined,
  expiresAt: status.expiresAt ?? undefined
});
